module.exports = __webpack_public_path__ + "img/absence.821ae844.svg";